import { TreeItem2 } from '@mui/x-tree-view';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useContext, useState } from 'react';
import { toast } from 'material-react-toastify';
import StarIcon from '@mui/icons-material/Star';
import { CategoryTreeNode } from '../../interfaces/Category/CategoryTreeNode';
import { CategoryTreeControllerContext } from './CategoryTreeController';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';
import { deleteCategory } from '../../api/Category';
import { Waiting } from '../../components/Waiting/Waiting';

interface CategoryTreeItemProps {
  category: CategoryTreeNode;
}

export const CategoryTreeItem = (props: CategoryTreeItemProps) => {
  const { onAddChild, onDelete } = useContext(CategoryTreeControllerContext);

  const [clickedDelete, setClickedDelete] = useState(false);
  const [hovering, setHovering] = useState(false);
  const [loading, setLoading] = useState(false);

  const iconStyle = {
    minHeight: 0,
    minWidth: 0,
    p: 0,
    mb: 0.25,
    opacity: hovering ? 1 : 0,
    visibility: hovering ? 'visible' : 'hidden',
    transition: 'opacity 0.3s',
  };

  const handleDelete = () => {
    setLoading(true);
    deleteCategory(props.category.id)
      .then(() => {
        toast.success('Kategori başarıyla silindi');
        onDelete?.();
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <TreeItem2
      itemId={props.category.id.toString()}
      label={
        <Box
          onMouseEnter={() => setHovering(true)}
          onMouseLeave={() => setHovering(false)}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Waiting open={loading} />
          <ConfirmDialog
            content={`Gerçekten ${props.category.name} isimli kategoriyi silmek istiyor musunuz?`}
            open={clickedDelete}
            onClose={() => setClickedDelete(false)}
            onConfirm={handleDelete}
            color='error'
          />
          <Typography sx={{ mr: 0.75 }}>{props.category.name}</Typography>
          {props.category.isPopular && (
            <Tooltip title='Popüler Kategori'>
              <StarIcon
                color='primary'
                fontSize='small'
                sx={{
                  minHeight: 0,
                  minWidth: 0,
                  p: 0,
                  mb: 0.25,
                }}
              />
            </Tooltip>
          )}
          <IconButton
            color='primary'
            size='small'
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              onAddChild?.(props.category.id);
            }}
            sx={iconStyle}
          >
            <AddIcon />
          </IconButton>
          <IconButton
            color='error'
            size='small'
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();

              setClickedDelete(true);
            }}
            sx={iconStyle}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      }
    >
      {props.category.children.map((c) => (
        <CategoryTreeItem key={c.id} category={c} />
      ))}
    </TreeItem2>
  );
};
